/* src/course_approvals/cards/CourseApprovalCard/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { map } from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { Paper, Typography } from '@material-ui/core';

import { ApproveTable, PaperHeader } from '../../../../app/components';
import { statusColors } from '../../../../config/constants/styles';
import styles from './styles';

import { updateCourseApproval } from '../../actions';
import {
  getSelectedCourses,
  getSelectedName,
} from '../../selectors';

class CourseApprovalCard extends React.Component {
  constructor(props) {
    super(props);
    this._onRespond = this._onRespond.bind(this);
  }

  _onRespond({ user, subID, status }) {
    this.props.updateCourseApproval({
      tutor: user,
      course: subID,
      status,
    });
  }

  renderLegend(classes) {
    return (
      <div>
        {map(statusColors, (v, k) => (
          <Typography key={k} className={classes.key} style={{ backgroundColor: v }}>
            {k}
          </Typography>
        ))}
      </div>
    );
  }

  render() {
    const { classes, courses, name, loading } = this.props;
    return (
      <Paper className={classes.paper}>
        <PaperHeader text={name}>
          {this.renderLegend(classes)}
        </PaperHeader>
        <ApproveTable
          data={courses}
          color
          onApprove={this._onRespond}
          onReject={this._onRespond}
          loading={false}
        />
      </Paper>
    );
  }
}

CourseApprovalCard.propTypes = {
  classes: PropTypes.object.isRequired,
  courses: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  courses: getSelectedCourses(state),
  name: getSelectedName(state),
  loading: state.courseApprovals.main.loading,
});

const mapDispatchToProps = dispatch => ({
  updateCourseApproval: params => dispatch(updateCourseApproval(params)()),
});

export default compose(
  withStyles(styles, { name: 'CourseApprovalCard' }),
  connect(mapStateToProps, mapDispatchToProps)
)(CourseApprovalCard);



// WEBPACK FOOTER //
// ./src/modules/course_approvals/cards/CourseApprovalCard/index.js